import { useMemo } from 'react'
import { useTimeZone } from 'context'
import { getDateSeparatedList } from 'utility/dateSeparatedList'

export const useSectionsByDate = <T extends { occurredAt?: string; createdAt?: string | null }>(
  items: T[] = [],
  includeTopDateSeparator: boolean = false,
  separateByMonth: boolean = false
) => {
  const { formatWithTimeZone } = useTimeZone()

  return useMemo(() => {
    const buildListSectionsWithTimeZone = getDateSeparatedList<T>(
      formatWithTimeZone,
      includeTopDateSeparator,
      separateByMonth
    )

    return buildListSectionsWithTimeZone(items)
  }, [formatWithTimeZone, includeTopDateSeparator, separateByMonth, items])
}
